import { Field } from "typegraph";
import ICourseFragmentProps from "../course/ICourseFragmentProps";
import TokenSession from "core/util/session/TokenSession";
import Course from "panels/catalog/entities/Course";
import StringUtil from "core/util/StringUtil";

export interface IRenderProgramTrackProps {
	courseFramentPops: ICourseFragmentProps;
	courseID:Number;
}

export interface IItem {
	track: ProgramTrackLazy;
	products?: TrackProductEager[];
	courseFramentPops: ICourseFragmentProps;
	pageNumber?: Number;
	showPaging?: Boolean;
}





class TrackStatus {
	@Field()
	public completed: number;

	@Field()
	public total: number;

	@Field()
	public type: "REQUIRED_COURSES" | "CREDITS_EARNED" | "COMPLETION_COUNT";

	@Field()
	public disableTrackView: boolean;
}

class TrackProductLazy {
	@Field()
	public id: string;

	@Field()
	public required: boolean;

	@Field()
	public sortIndex: number;
}


export class TrackProductEager {
	@Field()
	public id: string;

	@Field()
	public required: boolean;

	@Field()
	public sortIndex: number;

	@Field({
		entity: Course,
		params: (args: any) => ({
			params: { language: args.language || TokenSession.getLocale(), query: args.query || ""},
		}),
	})
	public course: Course;
}



class ProgramTrackLazy {
	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field({ aliasFor: "trackIconURL" })
	public iconUrl: string;

	@Field({ entity: TrackStatus })
	public status: TrackStatus[];

	@Field({ entity: TrackProductLazy })
	public products: TrackProductLazy[];

	@Field()
	public sequential: boolean;

	@Field()
	public sortIndex: number;
	
}

export class ProgramTrackEager {
	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field({ aliasFor: "trackIconURL" })
	public iconUrl: string;

	@Field({ entity: TrackStatus })
	public status: TrackStatus[];

	@Field({ entity: TrackProductEager })
	public products: TrackProductEager[];

	@Field()
	public sequential: boolean;

	@Field()
	public sortIndex: number;

}


class ProgramLazy {
	@Field()
	public id: string;

	@Field({ entity: ProgramTrackLazy })
	public tracks: ProgramTrackLazy[];
}

export class ProgramEager {
	@Field()
	public id: string;

	@Field({ entity: ProgramTrackEager })
	public tracks: ProgramTrackEager[];
}

export class ProgramQueryLazy {
	@Field({
		entity: ProgramLazy,
		params: (args: any) => ({
			params: { id: args.id, language: args.language },
		}),
	})
	public program: ProgramLazy;
}

export class ProgramQueryEager {
	@Field({
		entity: ProgramEager,
		params: (args: any) => ({
			params: { id: args.id, language: args.language },
		}),
	})
	public program: ProgramEager;
}




export class ProductQuery {
	@Field({
		entity: TrackProductEager,
		//params: (args: any) => ({ params: StringUtil.toInteger(args.pageNumber) ? { programTrackId: args.id, pageNumber: StringUtil.toInteger(args.pageNumber), pageSize: StringUtil.toInteger(args.pageSize) } : { programTrackId: args.id } })
		params: (args: any) => ({
			params: {
				programTrackId: args.id,
				pageNumber: StringUtil.toInteger(args.pageNumber),
				pageSize: StringUtil.toInteger(args.pageSize),
			},
		}),
	})
	public programTrackProducts: TrackProductEager[];
}


// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/overview/ProgramQueries.ts